import * as React from 'react';
import ICommonText from './ICommonText';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../components/common/DeleteButton';

interface CommonTextListRowProps {
    CommonText: ICommonText;
    key: number;
    delete: (id: number) => void;
}

const CommonTextListRow = (props: CommonTextListRowProps) => {
    return (
        <tr>
            <td>{props.CommonText.text}</td>
            <td>
                <ButtonToolbar className="pull-right btn-group-sm">
                    <DeleteButton
                        onDelete={() => {
                            props.delete(props.CommonText.id);
                        }}
                        text={Translate('common-texts/list/row/delete/remove-this-common-text')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('common-texts/list/row/button-label/delete')}
                    </DeleteButton>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default CommonTextListRow;
